import Toggle from "@/components/Toggle";
import usePaymentSquareConfigStore from "@/stores/payment-square-config.store";
import { useState } from "react";

import toast from 'react-hot-toast';

function SquarePaymentForm() {
  const {
    isEnabled,
    setEnabled,
    squareTerminalId,
    setSquareTerminalId
  } = usePaymentSquareConfigStore();

  const [squareTerminalIdValue, setSquareTerminalIdValue] = useState<string>(squareTerminalId ?? '');

  const handleSaveConnectionInfo = () => {
    setSquareTerminalId(squareTerminalIdValue);
    toast.success('Datos guardados correctamente');
  }

  return (
    <>
    <div className="flex gap-4 mt-10">
      <div>
        <Toggle
          checked={isEnabled}
          onChange={() => setEnabled(!isEnabled)}
        />
      </div>
      Pago con Terminal (Square)
    </div>
    {isEnabled && (
    <div>
      <p className="mb-2">Ingresá el Id del dispositivo:</p>
      <div className="relative z-0 w-full mb-5 group">
        <input
          type="text"
          name="device_id"
          id="device_id"
          className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
          placeholder=" "
          required
          value={squareTerminalIdValue}
          onChange={(e) => setSquareTerminalIdValue(e.target.value)}
        />
        <label
          htmlFor="device_id"
          className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
        >
          ID del dispositivo
        </label>
      </div>
      <button
        type="submit"
        onClick={handleSaveConnectionInfo}
        className="bg-primary text-white rounded-md px-6 py-2 mt-2"
      >
        Guardar Datos
      </button>
    </div>
    )}
    </>
  )
}

export default SquarePaymentForm